import {AutocompleteOption, AutocompleteMappedOption} from './autocomplete_result';

const RESULT_RESPONSE_CONTENT = 'content';

/** @deprecated TODO: remove this */
export class HierarchyChildren {
  static initOptions(rawDataOptions) {
    const options = [];
    if (rawDataOptions && rawDataOptions.length > 0) {
      rawDataOptions.forEach((option) => {
        options.push(new AutocompleteOption(option));
      });
    }
    return options;
  }

  static initMappedOptions(rawDataOptions) {
    const options = [];
    if (rawDataOptions && rawDataOptions.length > 0) {
      rawDataOptions.forEach((option) => {
        options.push(new AutocompleteMappedOption(option));
      });
    }
    return options;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.options = HierarchyChildren.initOptions(this.rawData[RESULT_RESPONSE_CONTENT]);
    this.mappedOptions = HierarchyChildren.initMappedOptions(this.options);
  }

  getOptions() {
    return this.options;
  }

  getMappedOptions() {
    return this.mappedOptions;
  }
}

export default {HierarchyChildren};
